import type { ComponentTheme } from '../types/component-theme';

import { navigationToggleLinesStyles } from '../shared-styles';

const animatedToggleLineStyles =
    'h-0.5 w-full origin-left rounded-full bg-gray-500 transition-transform duration-300 ease-out';

export default {
    slots: {
        root: 'relative flex min-w-full items-center gap-4 pl-3.5 mb-4 h-12.5',
        logoWrap: 'flex h-15 w-15 shrink-0 items-center justify-center',
        logo: 'h-11 w-12 object-contain',
        titleWrap: 'overflow-hidden whitespace-nowrap',
        title:
            'font-(family-name:--primary-font) bg-linear-to-br from-gray-700 to-gray-500 bg-clip-text text-xl ' +
            'font-semibold tracking-tight text-transparent',
        mobileToggle: 'flex shrink-0 md:invisible',
        toggleButton: 'size-10! shrink-0',
        toggleLabel: 'sr-only',
        toggleLines: navigationToggleLinesStyles,
        toggleLine: 'h-0.5 w-full rounded-full bg-gray-500',
        toggleLineMiddle: animatedToggleLineStyles,
        toggleLineBottom: animatedToggleLineStyles
    },
    variants: {
        open: {
            true: {
                toggleButton: 'sidebar-toggle-button--floating',
                toggleLineMiddle: 'scale-x-100',
                toggleLineBottom: 'scale-x-100'
            },
            false: {
                toggleLineMiddle: 'scale-x-50',
                toggleLineBottom: 'scale-x-[0.25]'
            }
        }
    }
} satisfies ComponentTheme;
